module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAaCAYAAACzdqxAAAABJUlEQVRIie3WvS4EURgG4Gd/FBKx6FY0RINEoRCVO3ADlDoRIcFF0BC9Co1K4Q50ChHRSyQq8b+RIFZmM5uwZjmbNaLwlt+ZPJnznTNzTqZcOmvFCibRpbncYAeL+RidbRKspgMzyEVvfIXOH4Kruc2mgEYpZFNAK8nXqT+hFGi0oSUEfkYvLgLhQZyGwLkYfgyE+5OK0a4oBwINpV6PX3AfCLXHs/yQJDhC+3AeCA/jOATOoBsPgXBPUvFP97iATx/ar/e42ECPi0nF1Hqc2k/oH24YjrbgGjYRtNgh8CFGsYBpjOMkBL6uM3aHOYzh6F39ACNY/mKvVw7T6B5Qm10MYAOvCeNRa1YxhL2E8a3qhSV6aAqXmMf+d1OtyQTW4xN/G0tvLNVFJ3UIKHYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/public/gaikuan1.png
// module id = ypPR
// module chunks = 1